import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_CONTENT_COMPLETION: (query) => ({ query }),
    API: {
      GET_CONTENT_COMPLETION: apiResourceActionCreator('contentCompletion')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getContentCompletion${endpointQuery({ ...(query || {}) })}`, authToken, action.admin.api.getContentCompletion)

function* getContentCompletion(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload && action.payload.query));
}

const configuration = {
  name: 'getContentCompletion',
  action: action,
  sagas: getContentCompletion,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingContentCompletion: true
    }),
    success: (state, action) => {
      const skip = action.payload.contentCompletion.skip;
      const newContentCompletions = action.payload.contentCompletion.contentCompletions;
      const newContentCompletion = {
        ...action.payload.contentCompletion,
        contentCompletions: skip === 0 
          ? newContentCompletions 
          : [...state.contentCompletion.contentCompletions, ...newContentCompletions]
      };
      return ({
      ...state,
      isFetchingContentCompletion: false,
      contentCompletion: newContentCompletion
    })},
    failed: (state, action) => ({
      ...state,
      isFetchingContentCompletion: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getContentCompletion.js